import Vue from '@/main'
import { PLAN_TYPES } from '@/views/plansSubscriptions/constants.js'

const MainOrganization = () => import('./pages/MainOrganization.vue')
const SubOrganizations = () => import('./pages/SubOrganizationsList.vue')

const organizationRoutes = [
  {
    path: 'mainOrganization',
    name: 'mainOrganization',
    component: MainOrganization,
    meta: { requiresAuth: true, menuType: 'Organization & Users' },
  },
  {
    path: 'createOrganization',
    name: 'createOrganization',
    component: MainOrganization,
    meta: { requiresAuth: true, menuType: 'Organization & Users' },
  },
  {
    path: 'subOrganization',
    name: 'subOrganization',
    component: SubOrganizations,
    meta: { requiresAuth: true, menuType: 'Organization & Users' },
    beforeEnter: (to, from, next) => {
      if (Vue.$store.state.auth.session.organization.planType != PLAN_TYPES.CORPORATE) {
        return next({ name: "mainOrganization"})
      }
      return next()
    },
  },
  {
    path: 'createSubOrganization',
    name: 'createSubOrganization',
    component: MainOrganization,
    meta: { requiresAuth: true, menuType: 'Organization & Users' },
  },
]

export default organizationRoutes
